export const ingestButton = {
  defaultText: 'Ingest & Send to QC',
  retryText: 'Retry Ingestion',
  tooltipText:
    'Click this button to trigger initial VAST<br />ingest (required), manual ingest, OR<br /> if an asset is in PUBLISHING_ABORT state.',
  tooltipConfig: { delayShow: 300, delayHide: 200 },
};
